// extracted by mini-css-extract-plugin
export default {"btn":"feedback-options_btn__mOBnk","wrapper":"feedback-options_wrapper__PlLnK"};